import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import './MarkdownPreviewModal.css';

const MarkdownPreviewModal = ({ isOpen, toggle, title, content }) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg" scrollable>
            <ModalHeader toggle={toggle}>{title}</ModalHeader>
            <ModalBody className="markdown-preview-body">
                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                    {content}
                </ReactMarkdown>
            </ModalBody>
            <ModalFooter>
                <Button className="dt1520-button active-dt1520-button view-button default-button" onClick={toggle}>
                    Закрыть
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default MarkdownPreviewModal;